$(document).ready(function() {

    TECL_Validation.Initialise();
    TECL_GridEditorsCommon.Initialise();
    TECL_ProductSlider.Initialise($('.product-line'));
    TECL_Navigation.Initialise();
    TECL_MegaMenu.Initialise();
    TECL_Accordion.Initialise();
    TECL_Wishlist.Initialise();
    TECL_Reviews.Initialise();
    TECL_ProductAlerts.Initialise();

    $(".sliderProperty").slider({});

    function setLocalisationCookie(siteId) {
        document.cookie = "localisation=" + siteId + "; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
    }

    var name = "localisation";
    var nameEQ = name + "=";
    var cookieArray = document.cookie.split(';');
    var localisationCookieSet = false;

    for (var i = 0; i < cookieArray.length; i++) {
        var c = cookieArray[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            localisationCookieSet = true;
        }
    }

    if (!localisationCookieSet) {
        $('#localisationModal').modal('show');
    }

    $(".localisationInternational").click(function(e) {
        setLocalisationCookie("int");
        location.reload();
    });

    $(".localisationUK").click(function(e) {
        setLocalisationCookie("uk");
        location.reload();
    });

    $(".freeTextSearch").on("keydown", function(e) {
        if (e.keyCode == 13) {
            TECL_Master.RunFreeTextSearch(this, "/search");
            e.preventDefault();
        }
    });

    $(".pagination-select").select2();

    $(document).on("keypress", ".select2-search__field", function(e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
            return false;
        }
    });

    $(document).on('click', '.add-to-cart', function(e) {
        TECL_Basket.AddToBasket(e, $(this));
    });

    $(document).on('click', '.expand-order', function(e) {
        if ($(this).hasClass("collapsed")) {
            $(this).text("View Details");
        } else {
            $(this).text("Hide Details");
        }
    });

    $(".refine-search-anchor").click(function(e) {
        e.preventDefault();
        $("html,body").animate({
            scrollTop: $("#refineSearch").offset().top - 50
        });
    });

    $(document).on("keydown", ".checkout #signInSection", function(e) {
      if (e.keyCode == 13) {
          TECL_CheckoutMyDetails.AuthenticateUser();
      }
    });

    $(".ajax-loading").addClass("ajax-content-loading").html("<div class='ajax-content-loading-content'></div>");

    if(window.location.hash == "#requestHardCopy") {
      $('select.form-control option:contains("hard copy")').prop('selected', true);
    }

    if(window.location.hash == "#hotPicks") {
      $("html,body").animate({
          scrollTop: $(".heading-new-releases").offset().top - 60
      });
    }

    $(".card").matchHeight();
    $('[data-toggle="tooltip"]').tooltip();
});
